var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPartnerActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0117 3.03604C11.3354 3.1381 11.5556 3.43835 11.5556 3.77783V7.66668L14.6667 7.66669C14.9567 7.66669 15.2226 7.82804 15.3566 8.08527C15.4905 8.34251 15.4702 8.65289 15.3039 8.89048L9.85947 16.6682C9.6648 16.9463 9.31224 17.066 8.98847 16.964C8.6647 16.8619 8.44452 16.5616 8.44452 16.2222L8.44453 12.3333H5.33344C5.04343 12.3333 4.7775 12.172 4.64357 11.9147C4.50964 11.6575 4.52995 11.3471 4.69626 11.1095L10.1407 3.33181C10.3353 3.0537 10.6879 2.93398 11.0117 3.03604Z",
    fill: "#525252"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartnerActive);
export default __webpack_public_path__ + "static/media/partner-active.e5f7c6a4abea34d6d89915aed337fb84.svg";
export { ForwardRef as ReactComponent };